import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import PageAnimation from '@shared/components/page-animation'
import { mainBlock } from 'data/poluchite-bez-bankov'

import { Steps } from './sections/steps'

import styles from './style.module.scss'

export const View = () => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			imageAdornmentWrapClassName={styles.imageAdornment}
			data={mainBlock}
			buttonProps={{
				onClick: scrollToApplicationForm,
			}}
		/>
		<Steps />
		<ApplicationForms.Cross
			processBarText='Вероятность одобрения займа'
			formTitle='Заявка на заём при отказе в банке'
		/>
	</PageAnimation>
)
